"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnreadMark = exports.NotificationsWrapper = exports.NotificationsContent = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const NotificationsWrapper = exports.NotificationsWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ebh5fga2"
} : {
  target: "ebh5fga2",
  label: "NotificationsWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1ivkyd7",
  styles: "position:relative;display:flex;flex-direction:row;&>svg{margin-left:0.5em;}"
} : {
  name: "1ivkyd7",
  styles: "position:relative;display:flex;flex-direction:row;&>svg{margin-left:0.5em;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const NotificationsContent = exports.NotificationsContent = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ebh5fga1"
} : {
  target: "ebh5fga1",
  label: "NotificationsContent"
})("position:absolute;background-color:white;right:0;top:30px;box-sizing:border-box;width:300px;border:1px solid #cfd9ea;background-color:#ffffff;box-shadow:0 10px 15px 0 rgba(0, 0, 0, 0.1);border-radius:", ({
  $radius
}) => $radius || '10px', ";overflow:hidden;padding:0.5em 1em;@media screen and (max-width: 500px){position:fixed!important;top:50px!important;right:auto;left:50%;transform:translateX(-50%);max-width:90vw;}");
const UnreadMark = exports.UnreadMark = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ebh5fga0"
} : {
  target: "ebh5fga0",
  label: "UnreadMark"
})("position:absolute;display:flex;align-items:center;justify-content:center;top:-6px;left:10px;background:", ({
  theme
}) => theme.alert, ";height:18px;width:18px;border-radius:10px;");